import type { IAccountUser } from "app/sharing/SharingService";

import type { IMonitorKeywordsNavigationTargets } from "../monitorKeywordsNavigationTargets";
import type {
    IKeywordGroup,
    ISharedKeywordGroup,
} from "app/common/keyword-research/monitor-lists/monitorKeywordsTypes";

export interface IMonitorKeywordsStartPageProps {
    keywordGroups: IKeywordGroup[];
    sharedKeywordGroups: ISharedKeywordGroup[];
    users: IAccountUser[];
    isLoading?: boolean;
    navigationTargets: IMonitorKeywordsNavigationTargets;
}

export const TabFilter = {
    ALL: 0,
    MY: 1,
    SHARED: 2,
} as const;

export const TabFilterNaming = Object.keys(TabFilter);

export type GroupType = ISharedKeywordGroup;
export type TableData = Array<GroupType>;
type DropdownIDValues = "openListPage" | "openSerpPage" | "openPagesPage" | "edit" | "share" | "delete";
export type DropdownOnClickProps = { id: DropdownIDValues };
